import React, { useEffect, useState } from 'react';
import './login.css';
import { props } from '../../App';
import { urlHelp, urlLogin } from '../../components/URLlist/urlList';
import { saveConsoleLog } from '../../helpFunction/helpFunction';

import { FaEye } from 'react-icons/fa';
import { generateToken } from '../../firebase/firebaseConfiguration';
import { useCookies } from 'react-cookie';

export interface propsUserData {
  email?: string;
  pin?: string;
  notificationToken?: string;
  channel?: any;
}

const Login = (props: props) => {
  const [userData, setUserData] = useState<propsUserData>({ email: '', pin: '', notificationToken: '', channel: 'web' });
  const [showPassword, setShowPassword] = useState<'password' | 'number'>('password');
  const [showPasswordPosition, setShowPasswordPosition] = useState<{ x: number; width: number; y: number; height: number }>({ x: 0, y: 0, width: 0, height: 0 });
  const [cookies, setCookie, removeCookie] = useCookies(['notification', 'notificationAllow']);

  const UserToken = async () => {
    const token = await generateToken();
    await fetch('https://birthday.adibau.pl/birthday/saveToConsole', {
      credentials: 'include',
      method: 'post',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({ data: 'token Z generateToken' }),
    });
    await fetch('https://birthday.adibau.pl/birthday/saveToConsole', {
      credentials: 'include',
      method: 'post',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({ data: token }),
    });

    if (token) {
      setUserData({ ...userData, notificationToken: token });
      setCookie('notification', token, { maxAge: 12 * 30 * 24 * 60 * 60 * 1000 });
      setCookie('notificationAllow', 'ALLOW', { maxAge: 12 * 30 * 24 * 60 * 60 * 1000 });
    } else {
      setCookie('notificationAllow', 'FORBIDEN', { maxAge: 12 * 30 * 24 * 60 * 60 * 1000 });
    }
  };

  const loginSend = async () => {
    props.setSpinner(true);

    try {
      const data = await fetch(urlLogin, {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(userData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (data.status === 202) {
        await UserToken();
        props.setViews({ home: true });
      } else {
        props.setMassage({ text: 'Błędny email lub PIN', type: 'err' });
      }
      if (data.status >= 500) {
        props.setMassage({ text: 'Ups .... może później proszę', type: 'err' });
      }
    } catch (error) {
      saveConsoleLog(JSON.stringify(`APKA error z Login, ${error}`));
      props.setMassage({ text: 'Ups .... może później proszę', type: 'err' });
      props.setSpinner(false);
    } finally {
      props.setSpinner(false);
    }
  };

  const forgetPin = async () => {
    if (!userData.email?.includes('@') || !userData.email?.includes('.')) {
      props.setMassage({ text: 'Wpisz poprawny email !!!', type: 'err' });
      return;
    }
    props.setSpinner(true);
    try {
      fetch(urlHelp, {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({ email: userData.email }),
        headers: {
          'content-type': 'application/json',
        },
      })
        .then((res) => {
          return res.json();
        })
        .then((res) => {
          props.setMassage({ text: res.msg, type: res.status !== 202 ? 'err' : 'ok' });
        });
    } catch (err) {
      saveConsoleLog(JSON.stringify(`APKA error z Forget PIN, ${err}`));
    } finally {
      props.setSpinner(false);
    }
  };
  const registerVisible = () => {
    props.setViews({ register: true });
  };

  return (
    <>
      <div className={'loginContainer'}>
        <div className='DivImage'>
          <img className='LogoStyle' alt='logo' srcSet={require('../../assets/adibauBirthdayReminder.png')} />
        </div>

        <div className={'InputView'}>
          <input className='TextInput' type='email' inputMode='email' placeholder='Email' value={userData.email} onChange={(e) => setUserData({ ...userData, email: e.target.value })} maxLength={15} datatype='email-address' autoComplete='email' />

          <input
            className='TextInput password'
            pattern='[0-9]*'
            inputMode='numeric'
            type={showPassword}
            placeholder='PIN'
            onChange={(pin) => setUserData({ ...userData, pin: pin.target.value })}
            value={userData.pin}
            maxLength={15}
            onFocus={(e) => {
              setShowPasswordPosition({ x: e.target.offsetLeft, width: e.target.offsetWidth, y: e.target.offsetTop, height: e.target.offsetHeight });
            }}
          />
          <FaEye
            style={{
              position: 'absolute',
              display: showPasswordPosition.x ? 'block' : 'none',
              top: showPasswordPosition.y + showPasswordPosition.height / 2 / 2,
              left: showPasswordPosition.x + showPasswordPosition.width - 25,
            }}
            onClick={() => setShowPassword(showPassword === 'number' ? 'password' : 'number')}
          />
        </div>

        <div className='New_account_div'>
          <div className='New_account' onClick={registerVisible}>
            <p>New Account</p>
          </div>

          <div className='New_account' onClick={forgetPin}>
            <p>Forget PIN</p>
          </div>
        </div>

        <div className='loginBtn' onClick={loginSend}>
          <p>LOGIN</p>
        </div>
      </div>
    </>
  );
};

export default Login;
